import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isQuizNumber(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.QUIZ_NUMBER && typeof label === 'string' && typeof value === 'number';
}
function _formatQuizNumber(_ref) {
  let {
    field,
    value
  } = _ref;
  return {
    label: field.view.label,
    value
  };
}
export function formatQuizNumber(submission) {
  if (isQuizNumber(submission)) {
    return _formatQuizNumber(submission);
  }
  return undefined;
}
//# sourceMappingURL=quiz-number-preview.js.map